import "./locationBloodDrawInformationDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LocationBloodDrawInformationDetailsViewComponent
    from "./location-blood-draw-information-details-view/LocationBloodDrawInformationDetailsViewComponent";
import LocationBloodDrawInformationDetailsEditComponent
    from "./location-blood-draw-information-details-edit/locationBloodDrawInformationDetailsEditComponent";

interface LocationBloodDrawInformationDetailsViewEditComponentProps {
    locationDetails: any
    onUpdateBloodDrawInformationDetails: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const LocationBloodDrawInformationDetailsViewEditComponent = (props: LocationBloodDrawInformationDetailsViewEditComponentProps) => {
    const {locationDetails, onUpdateBloodDrawInformationDetails,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [locationInformation, setLocationLocationInformation] = useState<any>(undefined);

    const handleLocationInformationUpdate = useCallback((updatedLocationInformation: any) => {
        onUpdateBloodDrawInformationDetails(updatedLocationInformation);
        setMode("view");
    }, [onUpdateBloodDrawInformationDetails]);

    const handleLocationInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (locationDetails) {
            setLocationLocationInformation(locationDetails);
        }
    }, [locationDetails]);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange])
    return (
        <div className={'location-blood-draw-informatition-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LocationBloodDrawInformationDetailsViewComponent
                    locationInformation={locationInformation}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <LocationBloodDrawInformationDetailsEditComponent
                    locationInformation={locationInformation}
                    onUpdateComplete={handleLocationInformationUpdate}
                    onEditCancel={handleLocationInformationEditCancel}
                />
            }
        </div>
    );

};

export default LocationBloodDrawInformationDetailsViewEditComponent;